import {
    bexHttpClient
} from '../../clients';
import {
    OutlookAuthRequest,
    OutlookAuthResponseAPIResponse
} from '../bexService.types';

/**
 * Service class for performing Outlook configuration operations.
 */
class OutlookConfigService {

    /**
     * Creates a new Outlook configuration.
     * @param {OutlookAuthRequest} data - The data to create a new Outlook configuration.
     * @returns {Promise<OutlookAuthResponseAPIResponse>} The response from the server regarding newly created Outlook configuration.
     */
    async createOutlookConfig(data: OutlookAuthRequest): Promise<OutlookAuthResponseAPIResponse> {
        const response = await bexHttpClient.post('/outlook/config/add-secrets', data);
        return response;
    }

    /**
     * Gets the Outlook configuration.
     * @param {string} organizationId - The ID of the organization.
     * @returns {Promise<OutlookAuthResponseAPIResponse>} The response from the server regarding Outlook configuration.
     */
    async getOutlookConfig(organizationId: string): Promise<OutlookAuthResponseAPIResponse> {
        const response = await bexHttpClient.get(`/outlook/config/get-secrets?organizationId=${organizationId}`);
        return response;
    }

    /**
     * Deletes Outlook configuration.
     * @param {string} organizationId - The ID of the organization.
     * @returns {Promise<void>}
     */
    async deleteOutlookConfig(organizationId: string): Promise<void> {
        await bexHttpClient.delete('/outlook/config/delete-secrets', {
            data: {
                organizationId
            }
        });
    }

}

const outlookConfigService = new OutlookConfigService();
export { outlookConfigService };